import { render, staticRenderFns } from "./LeaveManageAdminView.vue?vue&type=template&id=767f7445"
import script from "./LeaveManageAdminView.ts?vue&type=script&lang=ts&external"
export * from "./LeaveManageAdminView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports